import {common_utils} from "../common/common_utils";

function game_3011_12_13()
{

}


game_3011_12_13.getWinInfo = function(detail)
{
  let winInfo = null;
  if(common_utils.isNull(detail))
  {
    return winInfo;
  }
  winInfo = "";
  let winValueInfo = "";
  let betsInfo = detail.BetsInfo;
  let index = 0;
  let winValue = 0;
  let TotalBet = common_utils.getValueToFixed(detail,"TotalBet");
  let TotalWin = common_utils.getValueToFixed(detail,"TotalWin");

  Object.keys(betsInfo).map(function(key) {
    let subitem = betsInfo[key];
    let win = subitem.winAmount;
    if(win > 0)
    {
      if(index > 0)
      {
        winValueInfo += " + ";
      }
      winValue += win;
      winValueInfo += (win  / 100).toFixed(2)
      index++;
    }
  });

  if(winValueInfo.length>0)
  {
    winInfo += "("+winValueInfo+")";
  }
  else
  {
    winInfo += "0.0";
  }
  let bet_index = 0;
  winInfo += " - ("
   Object.keys(betsInfo).map(function(key) {
     let subitem = betsInfo[key];
     let bet = subitem.betAmount;
     if(bet > 0)
     {
       if(bet_index > 0)
       {
         winInfo += " + ";
       }
       winValue -= bet;
       winInfo += (bet  / 100).toFixed(2)
       bet_index++;
     }
  });
  winInfo += ")"
  winInfo += " = (" +TotalWin+" - "+TotalBet+")";
  winInfo += " = "+((winValue) / 100).toFixed(2);
  return winInfo;
}

export {
  game_3011_12_13
};



// WEBPACK FOOTER //
// ./src/components/esports/game_3011_12_13.js